<script>
import { mapState ,mapActions } from "vuex";
import IconGalerias from "@/assets/img/icon/section/IconGalerias.vue";

export default {
    name: "galeria",
    components: {
    IconGalerias
},
    data() {
        return {
            //FF
            filter: {
              year: ""
            },
        };
    },
    computed: {
      ...mapState("GaleriaModule", ["yearGaleria", "monthGaleria"]),
    },
    watch:{
      "filter.year": {
        handler() {
          this.getMonthGaleria();
        },
        deep: true,
      },
    },
    async created(){
      await this.getYear();
      await this.actualYear(); 
      await this.getMonthGaleria();
    },
    methods: {
        ...mapActions("GaleriaModule", ["getYearGaleria", "getGaleriaMonth"]),
        toMonthName(monthNumber) {
            const date = new Date();
            date.setMonth(parseInt(monthNumber) - 1);
            return date.toLocaleString("es-CL", { month: "short"}).replace(/\./, "");
        },
        async getYear(){
          let data_ = {
            id_empresa: this.$ls.get("user").id_empresa_fk,
            id_usuario: this.$ls.get("user").id_usuario,
          }
          await this.getYearGaleria(data_);
        },
        async getMonthGaleria(){
          let data_ = {
            id_empresa: this.$ls.get("user").id_empresa_fk,
            id_usuario: this.$ls.get("user").id_usuario, 
            year: this.filter.year.year
          }
          await this.getGaleriaMonth(data_);
        },
        async actualYear() {
          let max = Math.max.apply(Math, this.yearGaleria.map(e => e.year));
          return this.filter.year = { year: JSON.stringify(max) };
        }
    }
};
</script>
<template>

  <section id="galerias">

    <div class="row">
      <div class="col-12 mb-0">
        <h1 class="h1-custom font-700 mb-1 text-capitalize color-main d-flex align-items-center">
          <IconGalerias class="me-2 icon-svg-45"/>
          Galerías
        </h1>
  
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link
                to="/home"
                class="color-main"
              >
                <font-awesome-icon icon="fa-solid fa-house"></font-awesome-icon>
                Inicio
              </router-link>
            </li>
            <li class="breadcrumb-item text-capitalize active">
              Galerías
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="row d-flex align-items-center mt-2">
      <div class="col-12 col-lg-10 mb-3 mb-lg-0">
        <p class="text-secondary h5-custom mb-0">
          ¡Revive nuestros mejores momentos! Descarga y dale like a tus fotos favoritas
        </p>
      </div>
      <div class="col-12 col-lg-2 text-end">
        <v-select
          :options="yearGaleria"
          v-model="filter.year"
          label="year"
          placeholder="Año"
          class="vue-select"
          :clearable="false"
        >
        </v-select>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="border-bottom mb-3 pb-3"></div>
      </div>
    </div>

    <div 
      v-if="monthGaleria"
      class="row">
      <div 
        v-for="(n, i) in 12"
        :key="i"
        class="col-12 col-md-6 col-lg-3 col-xl-2 mb-4"
        :class="`${!monthGaleria.some((el) => el.month == n) ? 'disabled-click' : ''}`"
      >
        <router-link 
          :to="`/galeria/${filter.year.year}/${monthGaleria.some((el) => el.month == n) ? parseInt(monthGaleria.find((el) => el.month == n).month) : ''}`" 
          class="card card-shadow rounded-4 border-0"
        >
        <div 
          class="border-rounded-top bg-main"
          style="height: 30px;"
        >
        </div>
          <div class="card-body text-center">
              <h1 class="h1-custom mt-3 text-secondary font-700 text-capitalize">
                {{ toMonthName(n) }}
              </h1>
              <p class="h5 text-secondary text-opacity-50">
                <font-awesome-icon icon="fa-solid fa-folder" class="color-main"></font-awesome-icon>
                {{ monthGaleria.some((el) => el.month == n) ? monthGaleria.find((el) => el.month == n).cantidad_albumes : "0" }}
                Álbumes
              </p>
          </div>
        </router-link>
      </div>
    </div>
  </section>
</template>


